import { defineStore } from 'pinia';
import { reactive, ref } from 'vue';
import { assignState } from '@/store/index.js';
import useAuthStore from '@/store/modules/auth.js';
import { apiRetrieveBonusPhases } from '@/services/bonusPhase.js';

const getBonusPhaseGameConfigDefaultState = () => ({
  gameId: '',
  prizeValue: 0,
});

const useBonusPhaseStore = defineStore('bonusPhase', () => {
  const isBonusPhaseDailyModalShown = ref(false);
  const isBonusPhaseGameModalShown = ref(false);
  const bonusPhaseList = ref([]);
  const bonusPhasePuzzleGame = ref(null);
  const bonusPhaseLanternGame = ref(null);

  const bonusPhaseGameConfig = reactive(getBonusPhaseGameConfigDefaultState());

  const setBonusPhaseGameConfig = (data) => {
    assignState(bonusPhaseGameConfig, data);
  };

  const resetBonusPhaseGameConfigState = () => {
    assignState(bonusPhaseGameConfig, getBonusPhaseGameConfigDefaultState());
  };

  const resetDailyState = () => {
    assignState(isBonusPhaseDailyModalShown, false);
  };

  const resetBonusGameState = () => {
    assignState(isBonusPhaseGameModalShown, false);
    assignState(bonusPhasePuzzleGame, null);
    assignState(bonusPhaseLanternGame, null);

    resetBonusPhaseGameConfigState();
  };

  const dispatchRetrieveBonusPhases = async () => {
    try {
      const { parsedData, hasDailyReward, puzzleBonusGame, lanternBonusGame } = await apiRetrieveBonusPhases();

      // Reload user data since backend assigns points/games when daily reward is available
      if (hasDailyReward) {
        const authStore = useAuthStore();
        await authStore.dispatchRetrieveAuthUser();
      }

      bonusPhaseList.value = parsedData;

      if (puzzleBonusGame) {
        bonusPhasePuzzleGame.value = puzzleBonusGame;
      } else if (lanternBonusGame) {
        bonusPhaseLanternGame.value = lanternBonusGame;
      }
    } catch {
      bonusPhaseList.value = [];
    }
  };

  return {
    isBonusPhaseDailyModalShown,
    isBonusPhaseGameModalShown,
    bonusPhaseList,
    bonusPhasePuzzleGame,
    bonusPhaseLanternGame,
    bonusPhaseGameConfig,
    setBonusPhaseGameConfig,
    resetBonusPhaseGameConfigState,
    resetDailyState,
    resetBonusGameState,
    dispatchRetrieveBonusPhases,
  };
});

export default useBonusPhaseStore;
